import { useQuery } from '@tanstack/react-query';

import { getNotifsSent } from '../data-access/getNotifsSent';

export const useNotificationsSent = (roomId: string, notificationId: string) =>
  useQuery({
    queryKey: ['notifications-sent', roomId, notificationId],
    queryFn: () => getNotifsSent(roomId, notificationId),
  });
